import React from 'react';
import { connect } from 'react-redux';
import withRouter from 'js/withRouter';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';

import Loader from 'components/layout/Loader';

// display terms of the dealer for selling merchandise (e-commerce)
class ModalDealerItemSalesTermsOfService extends React.Component {
  render() {
    const {
      intl: { messages },
      show,
      close,
      cmsPage,
      owner,
    } = this.props;

    let dataUrl = '/api/pages/itemsalestermsofservice.json?';
    if (owner) {
      dataUrl += 'owner=' + (owner.username || owner.id);
    }

    return (
      <Modal show={show} onHide={close} size="lg" className="full-width">
        <Modal.Header closeButton>
          <Modal.Title>{messages.terms_of_service}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Data dataName="cmsSystemPageItemSalesTermsOfService" url={dataUrl} data={cmsPage} />

          <div className="themed">
            {cmsPage.pending ? <Loader /> : <CmsPage data={cmsPage.data} doUpdateActiveCms={false} />}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
ModalDealerItemSalesTermsOfService.defaultProps = {
  owner: null,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    cmsPage: state.data.cmsSystemPageItemSalesTermsOfService,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(ModalDealerItemSalesTermsOfService)));
